import axios from "axios";
import { API } from "../api";

const jsonHeaders = { "Content-Type": "application/json" };

export const getAllBrands = async () => {
  try {
    const { data } = await axios.get(`${API.DEV}/brands/list`);
    return data.data || data;
  } catch (err) {
    console.error("Error fetching brands:", err);
    throw new Error(err);
  }
};

export const getBrandStats = async () => {
  try {
    const { data } = await axios.get(`${API.DEV}/brands/stats`);
    return data.data || data;
  } catch (err) {
    console.error("Error fetching brand stats:", err);
    throw new Error(err);
  }
};

export const createBrand = async (payload) => {
  try {
    const { data } = await axios.post(`${API.DEV}/brands/create`, payload, {
      headers: jsonHeaders,
    });
    return data;
  } catch (err) {
    console.error("Error creating brand:", err);
    if (err.response?.data) return err.response.data;
    throw new Error(err);
  }
};

export const updateBrand = async (id, payload) => {
  try {
    const { data } = await axios.put(`${API.DEV}/brands/${id}`, payload, {
      headers: jsonHeaders,
    });
    return data;
  } catch (err) {
    console.error("Error updating brand:", err);
    if (err.response?.data) return err.response.data;
    throw new Error(err);
  }
};

export const deleteBrand = async (id) => {
  try {
    const { data } = await axios.delete(`${API.DEV}/brands/${id}`);
    return data;
  } catch (err) {
    console.error("Error deleting brand:", err);
    if (err.response?.data) return err.response.data;
    throw new Error(err);
  }
};
